import { defineStore } from 'pinia';

export const useNextCardStore = defineStore('nextcard', {
    state: () => ({
        loading: false,
        loaded: false,
        showHidden: false,
        show524: false,
        showFiltersMenu: false,
        showExclusionsSidebar: false,
        hide524Callout: false,
        users: [],
        pageNumber: 0,
        pageSize: 12,
        filters: {
            programs: [],
            types: [],
            banks: [],
            spends: [],
        },
        activeNextCard: {},
        activeOffenders: {},
        topCard: {},
    }),
    getters: {
        activeUser(state) {
            let user = state.users.find((obj) => {
                return obj.show_user;
            });
            let deadUser = {
                next_cards: [],
                omitted_cards: {
                    omit_offenders: [],
                    five_twenty_four_count: 0,
                },
                filters: {
                    types: [],
                    programs: [],
                    banks: [],
                    spends: [],
                },
            };

            return user ? user : deadUser;
        },
        getActiveUser() {
            this.users.find((user) => {
                if (user.show_user) {
                    return user;
                }
            });
        },
        nextCards() {
            return this.activeUser.next_cards;
        },
        offenders() {
            return this.activeUser.omitted_cards.omit_offenders;
        },
        showFive24FilterCallout() {
            if (this.$cookies.get('shownFive24Filter')) {
                return false;
            }
            if (this.hide524Callout) {
                return false;
            }
            if (this.activeUser.omitted_cards.five_twenty_four_count < 5) {
                return true;
            }
            return false;
        },
        fiveTwentyFourCount() {
            return this.activeUser.omitted_cards.five_twenty_four_count;
        },
        filteredNextCards(state) {
            state.pageNumber = 0;
            let filtered = this.nextCards.filter((nc) => {
                let hidden = state.showHidden ? true : !nc.hidden;
                let five24 = true;
                /*let five24 = state.show524
                    ? true
                    : !nc.contributes_to_five_twenty_four;*/
                let types =
                    state.filters.types.length === 0 ||
                    state.filters.types.includes(nc.type);
                let programs =
                    state.filters.programs.length === 0 ||
                    state.filters.programs.includes(nc.program.type);
                let spends =
                    state.filters.spends.length === 0 ||
                    state.filters.spends.some((e) => nc.min_spend <= e);
                let banks =
                    state.filters.banks.length === 0 ||
                    (nc.issuing_bank &&
                        state.filters.banks.includes(
                            nc.issuing_bank.institution_code
                        ));
                /*if (nc.contributes_to_five_twenty_four) {
                    hidden = true;
                }*/
                return hidden && programs && types && spends && banks && five24;
            });

            let topCardIndex = filtered.findIndex((card) => {
                return !this.showHidden ? !card.hidden : true;
            });

            if (topCardIndex > -1) {
                this.topCard = filtered.splice(topCardIndex, 1)[0];
            }

            return filtered;
        },
        ommitedCards() {
            return this.activeUser.omitted_cards;
        },
        paginatedNextCards(state) {
            let cards = this.filteredNextCards;
            const start = state.pageNumber * state.pageSize,
                end = start + state.pageSize;
            return cards.slice(start, end);
        },
        types() {
            return this.activeUser.filters.card_types;
        },
        programTypes() {
            return this.activeUser.filters.programs;
        },
        banks() {
            return this.activeUser.filters.institutions;
        },
        spends() {
            return this.activeUser.filters.spends;
        },
        pageCount(state) {
            let l = this.filteredNextCards.length,
                s = state.pageSize;
            return Math.ceil(l / s);
        },
    },
    actions: {
        async getNextCards() {
            this.loading = true;
            return ApiService.apiCall('/next-card', 'get')
                .then((response) => {
                    this.loaded = true;
                    this.users = response.data.users;
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            this.loading = false;
                        }, 800);
                        resolve();
                    });
                })
                .catch((response) => {
                    this.loading = false;
                    return Promise.reject(response);
                });
        },
        toggleFilter(filter, type) {
            if (this.filters[type].includes(filter)) {
                this.filters[type].splice(
                    this.filters[type].indexOf(filter),
                    1
                );
            } else {
                this.filters[type].push(filter);
            }
        },
        loadNextCards(user) {
            this.clearFilters();
            setTimeout(() => {
                this.users.forEach((obj) => {
                    obj.show_user = false;
                });
                user.show_user = true;
            }, 100);
        },
        clearFilters() {
            this.filters.types = [];
            this.filters.programs = [];
            this.filters.banks = [];
            this.filters.spends = [];

            this.types.forEach((obj) => {
                obj.checked = false;
            });
            this.programTypes.forEach((p) => {
                p.checked = false;
            });
            this.banks.forEach((b) => {
                b.checked = false;
            });
            this.spends.forEach((s) => {
                s.checked = false;
            });
            this.show524 = false;
        },
        goodProgramName(type) {
            let programName = type;
            switch (type) {
                case 'flexible_currency':
                    programName = 'travel';
                    break;
                default:
                    programName = type;
            }

            if (!programName) return '';
            return programName.replace(/\w\S*/g, function (txt) {
                return (
                    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                );
            });
        },
        toggleFiltersMenu() {
            this.showFiltersMenu = !this.showFiltersMenu;
        },
        gotoPage(p) {
            this.pageNumber = p;
        },
        nextPage() {
            this.pageNumber++;
        },
        prevPage() {
            this.pageNumber--;
        },
        setShowHidden(showHidden) {
            this.showHidden = showHidden;
        },
        setShow524(show) {
            this.show524 = show;
        },
        setPageSize(val) {
            this.pageSize = val;
        },
        setExclusionsSidebar(val) {
            this.showExclusionsSidebar = val;
        },
        setActiveNextCard(data) {
            this.activeNextCard = data.card;
            this.activeOffenders = data.offenders.hasOwnProperty(data.card.id)
                ? data.offenders[data.card.id]
                : {};
        },
        setFive24shownCookie() {
            this.hide524Callout = true;
            this.$cookies.set(
                'shownFive24Filter',
                '1',
                '365d',
                '/',
                window.location.hostname,
                true
            );
        },
    },
});
